/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$(document).ready(function() {
  $('.feature-row__image__slick').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    prevArrow: "<button type='button' class='slick-prev'><span class='sr-only'>Prev</span></button>",
    nextArrow: "<button type='button' class='slick-next'><span class='sr-only'>Next</span></button>"
  })
});
